
import { mapState, mapActions } from "vuex";
import profilePicturePreviewAndUpdate from "../common/profile-picture-preview-and-update.vue";

export default {
  components: { profilePicturePreviewAndUpdate },
  data() {
    return {
      saveLoading: false
    };
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  methods: {
    ...mapActions("auth", ["updateProfileBasicDetails"]),

    handleSave(photo) {
      this.saveLoading = true;
      let formData = new FormData();
      formData.append("avatar", photo);
      this.updateProfileBasicDetails(formData)
        .then((response) => {
          if (response.data.status === "success") {
            this.$nuxt.$emit("show-toast", {
              text: "Profile picture updated successfully",
              color: "success darken-2",
              icon: "done",
              flat: true
            });
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    }
  }
};
